import * as Yup from "yup";
import { TFunction } from "i18next";

export const objectShape = (t: TFunction) => ({
  delayForRedeem: Yup.number()
    .typeError(t("payfac.pageRatePlanModalRequiredField"))
    .required(t("payfac.pageRatePlanModalRequiredField")),
  value: Yup.number()
    .typeError(t("payfac.pageRatePlanModalRequiredField"))
    .required(t("payfac.pageRatePlanModalRequiredField")),
});
